import React from 'react';

const Loading = ({height = null, top = null}) => {
    const styleLDS = {};
    const styleDIV = {};
    if (height) {
        styleLDS.height = height;
    }
    if (top) {
        styleDIV.top = top;
    }
    return (
        <div id="append_loader" className="table_append_loader">
            <div className="loader-center">
                <div className="lds-ellipsis" style={styleLDS}>
                    <div style={styleDIV}></div>
                    <div style={styleDIV}></div>
                    <div style={styleDIV}></div>
                    <div style={styleDIV}></div>
                </div>
            </div>
        </div>
    )
}

export default Loading;